var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"itembox",on:{"click":_vm.Jump}},[_c('div',{staticClass:"left"},[_c('img',{staticClass:"left-img",attrs:{"src":_vm.info.url,"alt":""}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/user/spot.png"),"alt":""}})])
}]

export { render, staticRenderFns }